const analyticsEvents = {
  newsletter_signup: 'Newsletter Subscribe',
  click_product: 'Product Clicked',
  watch_video: 'Video Watched',
  visit_store: 'Store in Navigation Clicked',
  navigation_click: 'Navigation Item Clicked',
  announcement_banner_click: 'Announcement Banner Clicked',
  button_click: 'Button Clicked',
  scroll_to_top: 'Scroll to Top',
  trustpilot_click: 'Trustpilot Clicked',
  newsletter_subscribe: 'Newsletter Subscribe',
};

export default analyticsEvents;
